define('home/views/EditDiscussionCategoryView',[
    'jquery',
    'backbone-marionette',

    'home/templates/editDiscussionCategory',
], function (
    $,
    Marionette,

    editDiscussionCategoryTemplate
) {
    'use strict';

    var EditDiscussionCategoryView = Marionette.ItemView.extend({
        template: editDiscussionCategoryTemplate,
        className: 'discussion-form__categories',

        templateHelpers: function () {
            return {
                categories: this.model.thread.forum.channel.getCategories(),
                existingCategory: this.existingCategory,
            };
        },

        initialize: function () {
            this.existingCategory = this.model.topics.getCategoryTopics()[0];
        },

        events: {
            'change input[name=category]': 'categoryChanged',
        },

        onDomRefresh: function () {
            this.$('[data-toggle=tooltip]').tooltip();
        },

        categoryChanged: function (evt) {
            this.model.set({ category: $(evt.currentTarget).val() });
        },
    });

    return EditDiscussionCategoryView;
});

